<template>
  <div class="container">
      <div class="mianView">
          <div class="topMian">
                <div class="topmianBG">
                     <img class="topmianBG_image" src="../../../assets/images/img_wave.png" />
                </div>
                <div class="topMianView">
                    <div class="topMianView1">
                        <span class="topMianView_span1">今日用电(kwh)</span>
                        <span class="topMianView_span2">86.37</span>
                        <span class="topMianView_span3">昨日同期 94.47</span>
                        <div class="topMianview_div">
                             <span class="topMianView_span4">18.10</span>
                             <img  class="icon_arrow"     src='../../../assets/images/icon_down_green.png' />
                        </div>
                    </div>
                </div>
          </div>

          <div class="bodyView">
              <div class="bodyViewLeft">
                    <span class="bodyView_span1">本月用电(kwh)</span>
                    <span class="bodyView_span2">2386.37</span>
                    <span class="bodyView_span3">上月同期 3494.47</span>
                    <div class="bodyView_div">
                        <span class="bodyView_span4">18.10</span>
                        <img  class="icon_arrow"     src='../../../assets/images/icon_down_green.png' />
                    </div>
              </div>
              <div class="bodyViewRight">
                  <span class="bodyView_span1">本年用电(kwh)</span>
                    <span class="bodyView_span2">45686.37</span>
                    <span class="bodyView_span3">上年同期 45794.47</span>
                    <div class="bodyView_div">
                        <span class="bodyView_span4">18.10</span>
                        <img  class="icon_arrow"     src='../../../assets/images/icon_down_green.png' />
                    </div>
              </div>
          </div>

          <div class="tableView">
              <div class="tableTop">
                  <div class="SegmentedView">
                      <span @click="changeSelect(0)" :class="['SegmentedItem0',selectIndex==0?'SegmentedItemSelect':'']">今日</span>
                      <span @click="changeSelect(1)" :class="['SegmentedItem1',selectIndex==1?'SegmentedItemSelect':'']">本周</span>
                      <span @click="changeSelect(2)" :class="['SegmentedItem2',selectIndex==2?'SegmentedItemSelect':'']">本月</span>
                      <span @click="changeSelect(3)" :class="['SegmentedItem3',selectIndex==3?'SegmentedItemSelect':'']">全年</span>
                  </div>
              </div>
              <div class="lineTableBg">
                  <div class="lineTableTop">
                      <img  class="lineTableTop_icon" src='../../../assets/images/icon_down_green.png' />
                      <span class="lineTableTop_span">能耗实时监控</span>
                  </div>
                  <div class="lineTableBody">
                      <chart-line :data-list="lineData" :xData="xData" :extra-option="optionLine" />
                  </div>
                  <div class="lineTableFoot">
                      <div class="lineTableFoot_item">
                          <div class="lineTableFoot_item_dot1"></div>
                          <span class="lineTableFoot_item_span">今日</span>
                      </div>
                      <div class="lineTableFoot_item1">
                          <div class="lineTableFoot_item_dot2"></div>
                          <span class="lineTableFoot_item_span">昨日</span>
                      </div>
                  </div>
              </div>
              <div class="barTableBg">
                  <div class="barTableTop">
                      <img  class="lineTableTop_icon" src='../../../assets/images/icon_down_green.png' />
                      <span class="lineTableTop_span">能耗各类项对比</span>
                  </div>
                  <div class="barTableBody">
                      <chart-pie :data-list="pieData" :extra-option="option" />
                  </div>
                  <div class="barTableFoot">
                      <div class="barTableFootItem" v-for="(item,index) in colorList" :key="index">
                          <div class="barTableFootItem1">
                              <div class="lineTableFoot_item_dot1" :style="{borderColor:item}"></div>
                              <span class="lineTableFoot_item_span">{{pieData[index].name}}</span>
                          </div>
                          <div class="barTableFootItem2">
                              <span class="barTableFootItem_span1">{{pieData[index].value}}</span>
                              <span class="barTableFootItem_span2">16.5%</span>
                          </div>

                      </div>
                  </div>
              </div>
          </div>

      </div>
  </div>
</template>
<script>
import util from "@/utils/util";
import ChartPie from "@/components/echarts/echart_pie/EchartPie.vue";
import ChartLine from "@/components/echarts/echart_line/EchartLine.vue";
import echart from "echarts";
import {calendarReport} from "@/utils/api";
import {mapState} from 'vuex';
export default {
    data(){
        return {
            newDate:'',
            selectIndex:0,
            colorList:['#FD9838','#FFD76A','#36CF8F','#07A5FF','#495CFF','#C457F0'],
             // 业务数据
            pieData: [
                {
                name: "办公室照明用电",
                value: 58
                },
                {
                name: "办公室空调用电",
                value: 43
                },
                {
                name: "会议室用电",
                value: 37
                },
                {
                name: "办公室照明用电1",
                value: 32
                },
                {
                name: "办公室空调用电1",
                value: 26
                },
                {
                name: "会议室用电1",
                value: 18
                },
            ],
      // 定制化配置覆盖默认配置
            option: {
                color: ['#FD9838','#FFD76A','#36CF8F','#07A5FF','#495CFF','#C457F0'],
                title:{text:'用电总数(kwh)'},
                graphic:{style:{text:"11.11"}}
            },
            xData:['1', '2', '3', '4', '5', '6', '7'],
            lineData: [{
                        name: '今日',
                        data: [820, 932, 301, 1434, 1290, '', ''],
                        type: 'line',
                        smooth: 0.5,// 设置折线弧度，取值：0-1之间
                        symbol:'circle',// 设置拐点为实心圆
                        symbolSize:6,// 设置折线上圆点大小
                        areaStyle: {
                            color: new echart.graphic.LinearGradient(0, 0, 0, 1, [{
                                offset: 0,
                                color: 'rgba(253, 152, 56, 1)',
                            }, {
                                offset: 1,
                                color: 'rgba(253, 152, 56, 0)'
                            }])
                        },
                    },{
                        name: '昨日',
                        data: [920, 732, 201, 1234, 290, 1330, 120],
                        type: 'line',
                        smooth: 0.5,// 设置折线弧度，取值：0-1之间
                        symbol:'circle',// 设置拐点为实心圆
                        symbolSize:6,// 设置折线上圆点大小
                        // areaStyle: {
                        // color: new echart.graphic.LinearGradient(0, 0, 0, 1, [{
                        //     offset: 0,
                        //     color: 'rgba(88, 213, 171, 0.3)',
                        // }, {
                        //     offset: 1,
                        //     color: 'rgba(88, 213, 171, 0)',
                        // }])
                        // },
                    }],
                    optionLine: {
                        color:['#FD9838','#36CF8F'],
                        xAxis: {
                            // name: '',
                            // type: 'category',
                            // axisLine: {
                            //     lineStyle: {
                            //     color: '#999'// 设置x轴颜色
                            //     }
                            // },
                            // axisTick: {
                            //     show: false//隐藏刻度线
                            // },
                            // 设置X轴数据旋转倾斜
                            axisLabel: {
                                rotate: 0, // 旋转角度
                                interval: 2  //设置X轴数据间隔几个显示一个，为0表示都显示
                            },
                            // // boundaryGap值为false的时候，折线第一个点在y轴上
                            // boundaryGap: false,
                            // data: []
                             title: {
                                text: '',
                             }
                        },
                    }
        }
    },
    components:{
        ChartPie,
        ChartLine,
    },
    computed: {
        ...mapState({
        common: state => state.common
        })
    },
    created(){

    },
     methods:{
         changeSelect(index){
            this.selectIndex =index;
         }

    }
}
</script>

<style lang="less" scoped>
@import "../../../assets/css/common.less";
.container{
   // height:100vh;
    background:#F4F3F2;
}

.mianView{
  //  position:absolute;
    width: 100%;
    background-color:#F4F3F2;
}
.topMian{
    width: 100%;
    height: 488px;
    position: relative;
}
.topmianBG{
    position:absolute;
    background-color: #FAFAFA;
    left: 0px;
    top: 0px;
    width: 100%;
    height: 318px;
    z-index: 1;
}
.topmianBG_image{
    width: 100%;
    height: 60px;
    margin-top: 258px;
}
.topMianView{
    position:absolute;
    top: 48px;
    left: 175px;
    border-radius: 100%;
    width: 400px;
    height:400px;
    justify-content: center;
    align-items: center;
    z-index: 2;
    // box-shadow:0px 0px 40px 0px rgba(253,152,56,0.2);
    border:12px solid rgba(253,152,56,1);

}
.topMianView1{
    border-radius: 100%;
    width: 376px;
    height:376px;
    display: flex;
    border:12px solid #FFE3C8;
    flex-direction: column;
    align-items: center;
    // justify-content: center;
}
.topMianView_span1{
   margin-top: 60px ;
   height:34px;
   font-size:24px;
   font-weight:400;
   color:rgba(153,153,153,1);
   line-height:34px;
}
.topMianView_span2{
    margin-top: 20px ;
    height:80px;
    font-size:80px;
    font-family:DIN-Medium,DIN;
    font-weight:500;
    color:rgba(51,51,51,1);
    line-height:80px;

}
.topMianView_span3{
     margin-top: 20px ;
     height:34px;
     font-size:24px;
     font-weight:400;
     color:rgba(80,133,164,1);
    line-height:34px;
}
.topMianview_div{
    margin-top: 20px ;
    justify-content: center;
    align-items: center;
    flex-direction: row;
}
.topMianView_span4{
    height:40px;
    font-size:28px;
    font-weight:500;
    color:rgba(22,188,132,1);
    line-height:40px;
    margin-right: 10px;

}
.icon_arrow{
    width: 28px;
    height: 28px;
}

.bodyView{
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}
.bodyViewLeft{
    margin-left: 100px;
    width: 255px;
    display: flex;
    // height: 255px;
    flex-direction: column;
    align-items: center;

}
.bodyViewRight{
    margin-right: 100px;
    width: 255px;
    display: flex;
    // height: 255px;
    flex-direction: column;
    align-items: center;
}
.bodyView_span1{
    height:34px;
    font-size:24px;
    font-weight:400;
    color:rgba(153,153,153,1);
    line-height:34px;
}
.bodyView_span2{
    margin-top: 8px;
    height:48px;
    font-size:40px;
    font-family:DIN-Medium,DIN;
    font-weight:500;
    color:rgba(51,51,51,1);
    line-height:48px;

}
.bodyView_span3{
    height:34px;
    font-size:24px;
    margin-top: 8px;
    font-weight:400;
    color:rgba(80,133,164,1);
    line-height:34px;
}
.bodyView_div{
     margin-top: 8px ;
    justify-content: center;
    align-items: center;
    flex-direction: row;

}
.bodyView_span4{
    height:40px;
    font-size:28px;
    font-weight:500;
    color:rgba(22,188,132,1);
    line-height:40px;
    margin-right: 10px;
}

.tableView{
    width: 100%;
    margin-top: 60px;
    flex-direction: column;
}
.tableTop{
    width:100%;
    height:120px;
    display: flex;
    background:rgba(255,255,255,1);
    // box-shadow:0px -8px 32px 0px rgba(0,0,0,0.06);
    border-radius:40px 40px 0px 0px;
}
.SegmentedView{
    margin-left: 176px;
    display: flex;
    margin-top: 38px;
    width: 404px;
     flex-direction: row;
     position: relative;
}
.SegmentedItem0{
    position:absolute ;
    left: 0px;
    width:100px;
    height:44px;
    text-align: center;
    border-radius:8px 0px 0px 8px;
    border:1px solid rgba(234,234,234,1);
    border-top-width: 2px;
    border-bottom-width: 2px;
    font-size:24px;
    font-weight:400;
    color:rgba(102,102,102,1);
    line-height:44px;
    z-index: 1;
}

.SegmentedItem1{
    position:absolute ;
    left: 100px;
    width:100px;
    height:44px;
    text-align: center;
    border:1px solid rgba(234,234,234,1);
    border-top-width: 2px;
    border-bottom-width: 2px;
    font-size:24px;
    font-weight:400;
    color:rgba(102,102,102,1);
    line-height:44px;
    z-index: 2;
}
.SegmentedItem2{
    position:absolute ;
    left: 200px;
    width:100px;
    height:44px;
    text-align: center;
    border:1px solid rgba(234,234,234,1);
    border-top-width: 2px;
    border-bottom-width: 2px;
    font-size:24px;
    font-weight:400;
    color:rgba(102,102,102,1);
    line-height:44px;
    z-index: 3;
}
.SegmentedItem3{
    position:absolute ;
    left: 300px;
    width:100px;
    height:44px;
    text-align: center;
    border-radius:0px 8px 8px 0px;
    border:1px solid rgba(234,234,234,1);
    border-top-width: 2px;
    border-bottom-width: 2px;
    font-size:24px;
    font-weight:400;
    color:rgba(102,102,102,1);
    line-height:44px;
    z-index: 4;
}
.SegmentedItemSelect{
    width:100px;
    z-index: 100;
    border:2px solid rgba(23,64,218,1);
    color:rgba(23,64,218,1);
}
.lineTableBg{
    width:100%;
    background:rgba(255,255,255,1);
    flex-direction: column;
}
.lineTableTop{
    width: 100%;
    display: flex;
    height: 90px;
    flex-direction: row;
    align-items: center;
}
.lineTableTop_icon{
    margin-left: 38px;
    width: 30px;
    height: 30px;
    margin-right: 14px;
}
.lineTableTop_span{
    height:40px;
    font-size:28px;
    font-weight:500;
    color:rgba(51,51,51,1);
    line-height:40px;
}
.lineTableBody{
    width: 100%;
    height: 344px;
}
.lineTableFoot{
    width: 100%;
    display: flex;
    height: 90px;
    flex-direction: row;
    justify-content: center;
    align-items: center;
}
.lineTableFoot_item{
    flex-direction: row;
    display: flex;
    align-items: center;
    margin-right: 60px;
}
.lineTableFoot_item1{
    align-items: center;
    display: flex;
    flex-direction: row;
}
.lineTableFoot_item_dot1{
    width:20px;
    height:20px;
    border-radius: 100%;
    border:4px solid rgba(253,152,56,1)
}
.lineTableFoot_item_dot2{
    width:20px;
    height:20px;
    border-radius: 100%;
    border:4px solid rgba(54,207,143,1)
}
.lineTableFoot_item_span{
    height:28px;
    font-size:20px;
    margin-left: 8px;
    font-weight:400;
    border-radius: 10px;
    color:rgba(153,153,153,1);
    line-height:28px;
}
.barTableBg{
    width:100%;
    background:rgba(255,255,255,1);
    flex-direction: column;
}
.barTableTop{
    display: flex;
    width: 100%;
    height: 90px;
    flex-direction: row;
    align-items: center;

}
.barTableBody{
    width: 100%;
    height: 300px;
    margin-bottom: 40px;
}
.barTableFoot{
    margin-left: 40px;
    width: 95%;
    flex-direction: row;
    display: flex;
    flex-wrap: wrap;
}
.barTableFootItem{
    width: 233px;
    display: flex;
    flex-direction: column;
    height: 102px;
    margin-bottom: 38px;
}
.barTableFootItem1{
    flex-direction: row;
     display: flex;
    align-items: center;
    margin-bottom: 8px;

}
.barTableFootItem2{
     display: flex;
    flex-direction: row;
    align-items: center;
}
.barTableFootItem_span1{
    margin-left: 28px;
    height:40px;
    font-size:28px;
    font-weight:500;
    color:rgba(51,51,51,1);
    line-height:40px;
}
.barTableFootItem_span2{
    margin-left: 8px;
    height:34px;
    font-size:24px;
    font-weight:400;
    color:rgba(153,153,153,1);
    line-height:34px;

}


</style>